// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import { CommonAPI } from '../features/common/CommonAPI';
import { AdminAPI } from '../features/admin/AdminAPI';
import { FrontAPI } from '../features/front/FrontAPI';
import { AgencyAPI } from '../features/AgencyAPI';
import { AiApi } from '../helper/api/aiAPI';
export const store = configureStore({
  reducer: {
    [CommonAPI.reducerPath]: CommonAPI.reducer,
    [AdminAPI.reducerPath]: AdminAPI.reducer,
    [FrontAPI.reducerPath]: FrontAPI.reducer,
    [AgencyAPI.reducerPath]: AgencyAPI.reducer,
    [AiApi.reducerPath]: AiApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(CommonAPI.middleware).concat(AdminAPI.middleware).concat(FrontAPI.middleware).concat(AgencyAPI.middleware).concat(AiApi.middleware),
});